import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { SortingState } from '@tanstack/react-table';

import {
  getOffer,
  getOfferList,
  getRecruiteeJobs,
} from '@/services/offerAdmin';

export const offerAdmin = createQueryKeys('offerAdmin', {
  list: ({
    pageIndex,
    pageSize,
    archived,
    search,
    sorting,
  }: {
    pageIndex: number;
    pageSize: number;
    archived?: boolean;
    search?: string;
    sorting: SortingState;
  }) => ({
    queryFn: () =>
      getOfferList({ pageIndex, pageSize, archived, search, sorting }),
    queryKey: [{ pageIndex, pageSize, archived, search, sorting }],
  }),
  detail: (id?: number) => ({
    queryFn: () => (id ? getOffer(id) : undefined),
    queryKey: [{ id }],
  }),
  recruiteeJobs: {
    queryKey: null,
    queryFn: getRecruiteeJobs,
  },
});
